import { Card, Checkbox, Space } from 'antd';
import ImportTitle from './ImportTitle';
import { PartnerProgramCard } from '../SupplierPartnerProgramsForm';
import React, {useState} from "react";

const ImportPartnerProgramsStep = ({ accountData, selectedFields, onFieldSelection }) => {
    // Use partnerable_programs if partner_programs doesn't exist
    const fieldKey = accountData?.partner_programs ? 'partner_programs' : 'partnerable_programs';
    const [partnerPrograms, setPartnerPrograms] = useState(TB.cloneDeep(accountData?.[fieldKey] || []));


    return (
        <div className="py-6">
            <ImportTitle
                title="Partner Programs"
                description="Select the partner programs you'd like to import to your profile"
            />

            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-certificate" />
                        <span>Partner Programs ({partnerPrograms?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={partnerPrograms?.every((_, idx) => selectedFields?.[fieldKey]?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                partnerPrograms?.forEach((_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection(fieldKey, newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="vertical" size={24} className="divide-gray-100 divide-x">
                    {TB.map(partnerPrograms, (program, index) => (
                        <div key={`partner-${TB.slugify(program.title || '')}-${TB.slugify(program.name || program.provider_name || '')}-${index}`}
                             className="flex items-start gap-4 flex-row">
                            <Space>
                                <Checkbox
                                    checked={selectedFields?.[fieldKey]?.[index]}
                                    onChange={(e) => onFieldSelection(fieldKey, {
                                        ...(selectedFields?.[fieldKey] || {}),
                                        [index]: !selectedFields?.[fieldKey]?.[index]
                                    })}/>
                            </Space>
                            <div style={{ flex: 1 }}>
                                <div className="-mt-3">
                                    <PartnerProgramCard profileItem={program} />
                                </div>
                            </div>
                        </div>
                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportPartnerProgramsStep;